import React, { useState } from 'react'
import CustomModal from 'components/organisms/CustomModal'

interface DeactivateCaseModalProps {
  show: boolean
  onHide: () => void
  onDeactivate: (deactivationReason: string) => void
}

const DeactivateCaseModal = (props: DeactivateCaseModalProps): JSX.Element => {
  const [reason, setReason] = useState('')
  return (
    <CustomModal
      show={props.show}
      showClose={true}
      showFooter={true}
      onHide={props.onHide}
      title='Deactivate Case'
      footerButtons={[
        {
          text: 'Deactivate Case',
          onClick: () => props.onDeactivate(reason),
          variant: 'danger',
          testid: 'deactivate-case-modal-deactivate-button'
        },
        {
          text: 'Cancel',
          onClick: props.onHide,
          variant: 'secondary',
          testid: 'deactivate-case-modal-cancel-button'
        }
      ]}
    >
      <div>
        <h2 className='mb-3'>
          <strong>Are you sure you want to deactivate this case?</strong>
        </h2>
        <p>
          Deactivating a case stops all case information from moving between
          client portal and your attorney’s software. It does not void any
          signed agreement you have with the attorney.
        </p>
        <p>
          You will have the option to reactivate the case if needed later from
          the client-level dashboard.
        </p>
        <p>
          <strong>Please provide a reason for deactivating the case:</strong>
        </p>
        <input
          type='text'
          className='w-100'
          placeholder='Optional'
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        ></input>
      </div>
    </CustomModal>
  )
}

export default DeactivateCaseModal
